class WriteOffOption {
  constructor(data = {}) {
    this.icon = data?.icon || 'time_daily';
    this.label = data?.label || 'subscription.period';
    this.description = data?.description || 'common.daily';
    this.periodicity = data?.periodicity || 'DAILY';
    this.active = true;
  }
}

export default WriteOffOption;
